import { isArray } from "@omnia/shared/utils/utils"
import { CroppingGroup } from "./dashboard"
import { PlanCroppingVm } from "./vm/planCroppingVm"
import { isArrayEmpty } from "@omnia/shared/utils/array"

export function hasAuthorizationsOnAnyInGroup(group: CroppingGroup | PlanCroppingVm[]) {

    const array = isArray(group)
        ? group
        : group?.cropping

    if (isArrayEmpty(array)) {
        return true
    }

    return array?.some(c => c.authorized)

}


export function canEditGroupRequirements(group: CroppingGroup) {
    return group.cropping
        && hasAuthorizationsOnAnyInGroup(group)
        && group.cropping.some(c => c.hasRequirements)
        && group.cropping.filter(c => c.selected).length === group.cropping.filter(c => c.selected && c.hasRequirements).length;
}

export function canResetGroupRequirements(group: CroppingGroup): boolean {

    let selection = group.cropping.filter(c => c.selected);

    if (!selection.length) {
        selection = group.cropping;
    }

    return selection.some(c => c.authorized && !!c.requirements && !c.isInPlan && !c.isZone)

}
